export default __webpack_public_path__ + "static/media/expBlack.bb06cbee.svg";